<template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      width="500"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn

        v-bind="attrs"
        v-on="on"
        color="primary" style="margin-left: 5px">
          <v-icon>mdi-microsoft-excel</v-icon>
          Exportar
        </v-btn>

      </template>

      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Export
        </v-card-title>

        <v-card-text>
            <v-row>
                <v-col cols="6">
                    <small>Desde:</small>
                    <v-dialog
                      ref="keyStart"
                      v-model="dialogStart"
                      :return-value.sync="start"
                      persistent
                      width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="start"
                              readonly
                              solo
                              style="margin: 5px 10px 0;"
                              v-bind="attrs"
                              v-on="on"
                              hide-details
                            />
                      </template>
                      <v-date-picker v-model="start" scrollable >
                        <v-spacer />
                        <v-btn text color="primary" @click="dialogStart = false">Cancel</v-btn>
                        <v-btn text color="primary" @click="$refs.keyStart.save(start)">OK</v-btn>
                      </v-date-picker>
                    </v-dialog>
                </v-col>
                <v-col cols="6">
                    <small>Hasta:</small>
                    <v-dialog
                      ref="keyEnd"
                      v-model="dialogEnd"
                      :return-value.sync="end"
                      persistent
                      width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="end"
                              readonly
                              solo
                              style="margin: 5px 10px 0;"
                              v-bind="attrs"
                              v-on="on"
                              hide-details
                            />
                      </template>
                      <v-date-picker v-model="start" scrollable >
                        <v-spacer />
                        <v-btn text color="primary" @click="dialogEnd = false">Cancel</v-btn>
                        <v-btn text color="primary" @click="$refs.keyEnd.save(end)">OK</v-btn>
                      </v-date-picker>
                    </v-dialog>
                </v-col>
            </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="dialog = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="handleExport"
          >
            Exportar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import apiDishOrders from '@/services/apiDishOrders'
export default {
    props: {
      locale: {
        type: String,
        default: 'es'
      },
    },
    data () {
      return {
        dialog: false,
        dialogStart: false,
        dialogEnd: false,
        start: new Date().toISOString().split('T')[0],
        end: new Date().toISOString().split('T')[0],
      }
    },
    methods: {
      handleSaveDateStart(v) {
        alert(v)
         this.$refs.dialogDateStart.save(v)
        this.dialogStart = false
      },
      handleSaveDateEnd(v) {
        this.end = v
        this.$refs.dialogDateEnd.save(v)
        this.dialogEnd = false
      },
      async handleExport() {
        await apiDishOrders.export(this.start, this.end)
      },
    }
  }
</script>
